/**
 * @file paddle 客户案例 高校列表
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {IUniversityList} from '../../types';
import {Col, Row} from 'antd';

const UniversityList: React.FC<IUniversityList> = props => {
    return (
        <div className="paddle-cc-ulist">
            <div className="paddle-cc-ulist-list-wrap clear-both">
                <Row
                    className="paddle-cc-ulist-list"
                    gutter={20}
                >
                    {props.list.map(item => (
                        <Col
                            key={`${item.title}${item.text}`}
                            xs={6}
                            className="paddle-cc-ulist-item-wrap"
                        >
                            <div
                                className="paddle-cc-ulist-item"
                            >
                                {!!item.iconUrl
                                && (
                                    <div
                                        className="paddle-cc-ulist-item-icon"
                                        style={{backgroundImage: `url(${item.iconUrl})`}}
                                    />
                                )}
                                <div className="paddle-cc-ulist-item-info">
                                    <div className="paddle-cc-ulist-item-title">
                                        {item.title}
                                    </div>
                                    <div className="paddle-cc-ulist-item-text">
                                        {item.text}
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
};

export default UniversityList;
